<template>
  <div class="container">

    <header class="header">
        <a href="#/" class="logo">
            <img class="float:left;" src="../assets/images/logo_main.png" alt="">
            <span style="color:#ff8a23;font-size:150%;">广州市东控工程项目管理有限公司</span>
        </a>

        <div class="top_content">
            <el-menu :default-active="activeIndex" background-color="#409eff" text-color="#fff" active-text-color="#ff8a23" mode="horizontal" >
              <template v-for="item in navList">
                <el-menu-item v-if="item.children==null || item.children.length==0" :index="item.index" @click="clickToRouter(item.uri)">{{item.name}}</el-menu-item>
                <el-submenu v-else :index="item.index">
                  <template slot="title">{{item.name}}</template>
                  <el-menu-item v-for="subItem in item.children" :index="subItem.index" @click="clickToRouter(subItem.uri)">{{subItem.name}}</el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
        </div>

    </header>

    <router-view class="content_body"></router-view>


  </div>
</template>
<script>
export default {
    data: function() {
        return {
            activeIndex: '1',
            navList:[],
        }
    },
    created: function() {
      this.initData();
    },
    methods: {
      initData() {
          var self = this;
          this.$http.get(self.globalUrl.navInfo).then(function(res) {
              if (res.data.code == 200000) {
                  self.navList = res.data.data;
              }
          });
      },
      clickToRouter(uri){
        this.$router.push(uri);
      }

    }
}
</script>
<style media="screen" lang="less">
/*0-768px以上宽度container为100%*/
.container {
 padding-right: 15px;
 padding-left: 15px;
 margin-right: auto;
 margin-left: auto;
}
/*768-992px以上宽度container为750px*/
@media (min-width: 768px) {
 .container {
 width: 750px;
 }
}
/*992-1200px以上宽度container为970px*/
@media (min-width: 992px) {
 .container {
 width: 970px;
 }
}
/*1200px以上宽度container为1170px*/
@media (min-width: 1200px) {
 .container {
 width: 1170px;
 }
}

header.header {
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 150px;
    border-radius: 4px;
    .logo {
        display: block;
        height: 80px;
        padding-top: 7px;
        width: 100%;
        text-align: left;
        color: #1ab394;
        line-height: 36px;
        font-size: 24px;
        img {
            height: 60px;
        }
    }
    .top_content {
        display: block;
        height: 66px;
        color: #ddd;
        line-height: 36px;
        &>ul.nav{
            cursor:pointer;
            max-height: 100%;
            &>li{
                float:left;
                padding     : 9px 10px 9px 15px;
                // border-bottom: 1px solid #23262E;
                &>a{
                    display: block;
                    color       : #fff;
                    i{
                        float: right;
                        line-height: 30px;
                        color   : #999;
                    }
                }
                &>a.router-link-active{
                    background-color: #ff8a23;
                }

                &:hover{
                    background-color: #4d515e;
                    &>ul.sub{
                      display: block;
                    }
                }

                ul.sub{
                    position:absolute;
                    z-index:100;
                    display: none;
                    li{
                       background-color: #4d515e;
                        display: block;
                        padding-top: 5px;
                        &>a{
                            max-width: 100%;
                            max-height: 100%;
                            color   : #ddd;
                            &:hover{
                                color   : #fff;
                            }
                        }
                        &>a.router-link-active{
                            color   : #fff;
                            background-color: #ff8a23;
                        }

                    }
                }
            }
        }
    }
}

.cpy_info{
  margin-top: 2px;
}

.footer {
    padding     : 9px 10px 9px 15px;
    height: 80px;
    background-color: #000;
    width: 100%;
    color: #fff;
}

.article{
  margin-top: 2px;
  height: 300px;

  &>ul.article-list{

    &>li{

      &>a.router-link-active{
          color   : #fff;
          background-color: #ff8a23;
      }
    }
  }
}




</style>



// WEBPACK FOOTER //
// home.vue?4c986af2